import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step4 } from '../../../../shared/models/component-messages/mapaAT/step4';
import { CTRL_334 } from '../../../validators/334/ctrl334';
import { FormMapaATControlNames } from '../formMapaATControlNames';
import { SousTraitanceOui } from '../models/SousTraitanceOui';

@Component({
  selector: 'app-sous-traitance-oui',
  templateUrl: './sous-traitance-oui.component.html'
})
export class SousTraitanceOuiComponent implements OnInit {

  @Input() uid = '';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
  @Input() sousTraitanceOui: SousTraitanceOui;
  @Input() index = 0;
  public rg1 = CTRL_334.id + '_';

  public step4 = new Step4();

  constructor() { }

  public ngOnInit() {
    if (this.sousTraitanceOui == null) this.sousTraitanceOui = new SousTraitanceOui();
    this.parentForm.addControl(this.getStepId() + this.rg1 + this.index, new FormControl({ rgCtrls: FormMapaATControlNames.getCtrl_334Names_json(this.index) }));
   }

  getUid() {
    return this.uid + '_SepSep_SousTraitanceOui';
  }

  getStepId() {
    return this.uid.substring(0, this.uid.indexOf("SepSep"));
  }

  public getUidTypeMontant() {
    return this.getUid() + '_SepSep_TypeMontant';
  }

  public ngOnDestroy() {
    this.parentForm.removeControl(this.getStepId() + this.rg1 + this.index);
  }
}
